// @ts-strict
import { Component, Input } from '@angular/core';
import { LMRouteComponentService } from '@services/index';


@Component({
  selector: 'lm-field-picker-help',
  standalone: false,
  templateUrl: './lm-field-picker-help.component.html',
  styleUrls: [ './lm-field-picker-help.component.scss' ],
  providers: [ LMRouteComponentService ]
  })
export class LMFieldPickerHelpComponent {

  @Input() uiFieldSpec!: UIFieldSpec;
}

